<!--
Component for the spaces carousel.
-->
<template>
  <div class="spacesCarouselContainer">

    <HomepageCarousel v-if="spacesToUse.length" name="spaces" :isPrimary="1===1">
      <CarouselItem v-bind:key="index" v-for="(space, index) in spacesToUse" :id ="'spaces' + index">
        <div class="spaceItem">
          <span id="spaceNameTxt">{{ space.studySpaceName }}</span>
          <div class="spaceInfo">
            <span class="ssSpan">
              <div id="ss2" :class="spacesStyle[index]"></div>
              <p class="ssText">{{ spacesText[index] }}</p>
            </span>
            <p class="spaceOccInfo">{{ getSpaceMessage(space) }}</p>
          </div>
        </div>
      </CarouselItem>
    </HomepageCarousel>

    <ViewMoreButton :text="'Book a space'" :featureLink="'/findaspace/1'" :isPrimary="1===1"></ViewMoreButton>
  </div>

</template>

<script setup>
import axios from 'axios'
import HomepageCarousel from '@/components/homepage/HomepageCarousel.vue'
import CarouselItem from '@/components/homepage/CarouselItem.vue'
import ViewMoreButton from './ViewMoreButton.vue'
// import * as lst from '@/components/localStorage.js'
import { ref, onMounted } from 'vue'

const props = defineProps({
  preferredSpaceNames: Array,
  fakeTime: String
})

const spacesToUse = ref([])
const spacesText = ref({ '0': '', '1': '', '2': '', '3': '' })
const spacesStyle = ref(['ssIndImg', 'ssIndImg', 'ssIndImg', 'ssIndImg'])


onMounted(() => {
  getSpaces()
})


function getSpaces () {
  axios.get('/timetable/studyspaces/available', { withCredentials: true })
    .then(response => {
      const gotspaces = response.data
      // WCSC-1267 cut to 4 but preferentially show Main Library and JMS spaces
      const prefNames = props.preferredSpaceNames
      spacesToUse.value = []
      let spacesUsed = {}
      const maxSpaces = 4
      for (let space of gotspaces) {
        if (prefNames.indexOf(space.studySpaceName) != -1) {
          spacesToUse.value.push(space)
          spacesUsed[space.studySpaceName] = 1
        }
      }
      console.log('found ' + Object.keys(spacesUsed).length + ' preferred spaces: ' + Object.keys(spacesUsed))
      for (let space of gotspaces) {
        let spaceNamesUsed = Object.keys(spacesUsed)
        if (spaceNamesUsed.indexOf(space.studySpaceName) == -1) {
          if (spaceNamesUsed.length < maxSpaces) {
            spacesToUse.value.push(space)
            spaceNamesUsed = Object.keys(spacesUsed)
            spacesUsed[space.studySpaceName] = 1
          }
        }
      }
      for (let i = 0; i < spacesToUse.value.length; i++) {
        if (isSpaceOpen(spacesToUse.value[i].openTime, spacesToUse.value[i].closeTime)) {
          spacesStyle.value[i] += ' space' + spacesToUse.value[i].occupancyStatus
          spacesText.value[i] = formatOcc(spacesToUse.value[i].occupancyStatus)
        } else {
          spacesStyle.value[i] += ' spaceclosed'
          spacesText.value[i] = 'Closed'
        }
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

function isSpaceOpen (ot, ct) {
  let d = newDate()
  let hms = cd(d.getHours()) +
            ':' + cd(d.getMinutes()) +
            ':' + cd(d.getSeconds())
  let spaceIsOpen
  if (ct < ot) {
    let checkOpen = (hms > ct && hms >= ot)
    let morningOpen = (hms < ct)
    let compareOpen = checkOpen || morningOpen
    spaceIsOpen = compareOpen
  } else if (ct == ot && ct != null) {
    spaceIsOpen = true
  } else {
    let todayHasOpeningTimes = ot != null && ct != null
    let betweenOpeningTimes = (hms >= ot && hms <= ct)
    const isOpen = todayHasOpeningTimes && betweenOpeningTimes
    spaceIsOpen = isOpen
  }
  return spaceIsOpen
}

function cd (i) {
  return (i + '').padStart(2, '0')
}

function newDate () {
  let d = new Date()
  if (typeof props.fakeTime !== 'undefined') {
    let hhmm = props.fakeTime.split(':')
    d.setHours(hhmm[0])
    d.setMinutes(hhmm[1])
  }
  return d
}

function formatOcc (status) {
  if (status == 1) {
    return 'Spaces'
  } else if (status == 2) {
    return 'Some'
  } else {
    return 'Limited'
  }
}

function getSpaceMessage (space) {
  if (space.occupancyStatus == 1 && isSpaceOpen(space.openTime, space.closeTime)) {
    return 'A few people are here. You should have no problem finding a space.'
  } else if (space.occupancyStatus == 2 && isSpaceOpen(space.openTime, space.closeTime)) {
    return 'There’s some traffic here, but you may be able to find a space.'
  } else if (space.occupancyStatus == 3 && isSpaceOpen(space.openTime, space.closeTime)) {
    return 'This place is popular! It may be difficult to find a space.'
  } else {
    return 'This space is closed.'
  }
}

</script>

<style>
.ssText {
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
}

.spaceItem {
  display: flex;
  flex-flow: column wrap;
  color: var(--uog-dark-blue);
}

#spaceNameTxt {
  font-weight: bold;
  padding-left: 3px;
  white-space: pre-line;
}

.spaceOccInfo {
  white-space: pre-line;
  margin-left: 20px;
}

.spaceInfo {
  display: flex;
  align-items: center;
  margin-top: 7px;
}

.ssIndImg {
  display: block;
  float: none !important;
}

.ssSpan {
  width: fit-content;
  display: block;
}
.ssSpace {
  background-color:#ffffff;
  width:50%;
  position: relative;
  min-height:200px;
}

.infoContainer {
  display: flex;
  flex-flow: column wrap;
  word-wrap: break-word;
  white-space: pre-line;
  justify-content: center;
  height: fit-content;
  margin: 5px;
  padding: 5px;
}
</style>
